export default class DtoNetwork {
    constructor(obj) {
        this.idStation = obj.idStation // Long,
        this.typeCode = obj.typeCode // Option[Long],
        this.natureCode = obj.natureCode // Option[Long],
        this.codeMaterial = obj.codeMaterial // Option[Long],
        this.length = obj.length // Option[Double]
    }
}